import React from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import About from "@/components/site/About";
import Projects from "@/components/site/Projects";
import Testimonials from "@/components/site/Testimonials";
import ServiceArea from "@/components/site/ServiceArea";
import ContactForm from "@/components/site/ContactForm";
import Footer from "@/components/site/Footer";

const Home = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main>
        <Hero />
        <Services />
        <About />
        <Projects />
        <Testimonials />
        <ServiceArea />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
